/*
 * @Author: wangwei
 * @Date: 2024-03-22 22:24:00
 * @LastEditTime: 2024-03-23 00:03:19
 * @FilePath: main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './core/lazy_use'
import '@/style/global.less'
import {
    getUrlParam
} from './utils/utils'
// import VConsole from 'vconsole'
Vue.config.productionTip = false

// const vConsole = new VConsole()

// Vue.use(vConsole)

const headers = {
    'token': `Bearer ${getUrlParam('Authorization')}`,
    'TenantId': getUrlParam('TENANT-ID'),
    'UserType': getUrlParam('USER-TYPE'),
    'UserTenantUserTypeId': getUrlParam('USER-TENANT-USER-TYPE-ID'),
};
const communityId = getUrlParam('CommunityId');
const roomId = getUrlParam('roomId');
const userId = getUrlParam('userId');
const address = getUrlParam('address');
const userName = getUrlParam('userName');

if (headers.token && headers.TenantId && headers.UserType && headers.UserTenantUserTypeId) {
    localStorage.setItem('headers', JSON.stringify(headers));
}
if (communityId) {
    localStorage.setItem('communityId', communityId);
}
if (roomId) {
    localStorage.setItem('roomId', roomId);
}
if (userId) {
    localStorage.setItem('userId', userId);
}
if (address) {
    localStorage.setItem('address', decodeURIComponent(address));
}
if (userName) {
    localStorage.setItem('userName', decodeURIComponent(userName));
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')